import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const LIST: AppRouteRecordRaw = {
  path: '/account', // 运营
  name: 'account',
  component: DEFAULT_LAYOUT,
  meta: {
    locale: 'menu.account',
    requiresAuth: true,
    icon: 'icon-folder',
    order: 5,
  },
  children: [
    {
      path: 'accountManage', // The midline path complies with SEO specifications
      name: 'accountManage',
      component: () => import('@/views/operation/account/index.vue'),
      meta: {
        locale: 'menu.accountManage',
        requiresAuth: true,
        roles: ['*'],
      },
    },
    {
      path: 'accountChangeRecord', // The midline path complies with SEO specifications
      name: 'accountChangeRecord',
      component: () => import('@/views/operation/accountChangeRecord/index.vue'),
      meta: {
        locale: 'menu.accountChangeRecord',
        requiresAuth: true,
        roles: ['*'],
      },
    },
  ],
};

export default LIST;
